
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/browse/[categoryId]",
      function () {
        return require("private-next-pages/guide/browse/[categoryId]/index.tsx");
      }
    ]);
  